import styled from "styled-components/macro";

export const SelectIcon = styled.svg`
  color: ${({ theme }) => theme.color.brandPrimary.light};
`;

export const SelectField = styled.select``;

export const FieldContent = styled.label`
  display: block;
  cursor: pointer;
  position: relative;

  ${SelectField} {
    width: 100%;
    cursor: pointer;

    &:active + ${SelectIcon}, &:focus + ${SelectIcon} {
      transition: all 300ms ease;
    }
  }
  ${SelectIcon} {
    position: absolute;
    top: 50%;
    right: 8px;

    transform: translate(0, -50%);
  }
`;
